// extracted by mini-css-extract-plugin
export default {"box":"InfoBox_box__qFQXX"};